module.exports = __webpack_public_path__ + "static/media/townhouse_white_icon.f7db6202.svg";